import { SET_LOADER } from '../Types/Types';

export function setLoader(value) {
  return {
    type: SET_LOADER,
    value
  }
}
